<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<p class="noind"><i>The following abbreviations are used in the text:</i></p>
<p class="bigspace">
</p><table>
<tbody><tr>
<td colspan="2" valign="top"><div style="margin-bottom:5pt"><b>Tanakh (Old Covenant):</b></div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Genesis (Gen.)</div></td>
<td valign="top"><div style="margin-left:1em">Psalms (Ps.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Exodus (Exod.)</div></td>
<td valign="top"><div style="margin-left:1em">Proverbs (Prov.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Leviticus (Lev.)</div></td>
<td valign="top"><div style="margin-left:1em">Isaiah (Isa.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Numbers (Num.)</div></td>
<td valign="top"><div style="margin-left:1em">Jeremiah (Jer.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Deuteronomy (Deut.)</div></td>
<td valign="top"><div style="margin-left:1em">Ezekiel (Ezek.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Joshua (Josh.)</div></td>
<td valign="top"><div style="margin-left:1em">Hosea (Hos.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">1 Samuel (1 Sam.)</div></td>
<td valign="top"><div style="margin-left:1em">Zechariah (Zech.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">2 Samuel (2 Sam)</div></td>
<td valign="top"><div style="margin-left:1em">Malachi (Mal.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Nehemiah (Neh.)</div></td>
<td valign="top"></td>
</tr>
<tr>
<td colspan="2" valign="top"><div style="margin-bottom:5pt; margin-top:40pt"><b>Brit Chadasha (New Covenant):</b></div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Matthew (Matt.)</div></td>
<td valign="top"><div style="margin-left:1em">Philippians (Phil.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Acts of the Apostles (Acts)</div></td>
<td valign="top"><div style="margin-left:1em">Colossians (Col.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Romans (Rom.)</div></td>
<td valign="top"><div style="margin-left:1em">2 Timothy (2 Tim)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">1 Corinthians (1 Cor.)</div></td>
<td valign="top"><div style="margin-left:1em">Hebrews (Heb.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">2 Corinthians (2 Cor.)</div></td>
<td valign="top"><div style="margin-left:1em">1 Peter (1 Pet.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Galatians (Gal.)</div></td>
<td valign="top"><div style="margin-left:1em">Revelation (Rev.)</div></td>
</tr>
<tr>
<td valign="top"><div style="margin-left:1em">Ephesians (Eph.)</div></td>
<td valign="top"></td>
</tr>
</tbody></table>
<p class="bigspace">
</p><p class="noind"><b>Talmud:</b></p>
<p class="smallspace">
</p><p class="noind">First order: Seeds</p>
<p class="hang1"><i>Berakhot</i> (<i>Ber</i>.)—Blessings: laws relating to prayer.</p>
<p class="mediumspace">
</p><p class="noind">Second order: Seasons</p>
<p class="hang1"><i>Shabbat</i> (<i>Shab</i>.)—Sabbath: most of the laws governing the Sabbath.</p>
<p class="hang1"><i>Pesachim</i> (<i>Pes</i>.)—Paschal Offerings: the laws concerning Passover.</p>
<p class="hang1"><i>Yoma</i>—the Day: concerning <i>Yom Kippur</i> (Day of Atonement).</p>
<p class="hang1"><i>Sukkah</i> (<i>Sukk</i>.)—Booth: concerning the Festival of <i>Sukkot</i> (Tabernacles).</p>
<p class="hang1"><i>Megillah</i> (<i>Meg</i>.)—Scroll: concerning the writing and public reading of Torah, the Prophets, and the scroll of Esther.</p>
<p class="mediumspace">
</p><p class="noind">Third Order: Women</p>
<p class="hang1"><i>Nedarim</i> (<i>Ned</i>.)—Vows: laws concerning vows.</p>
<p class="hang1"><i>Sotah</i> (<i>Sot</i>.)—A woman suspected of adultery: how to deal with such a case; also concerning the Priestly Benediction.</p>
<p class="hang1"><i>Kiddushin</i> (<i>Kidd</i>.)—Betrothals: laws governing the betrothal relationship.</p>
<p class="mediumspace">
</p><p class="noind">Fourth Order: Torts</p>
<p class="hang1"><i>Avot</i> (<i>Av</i>.)—Fathers: a compilation of the sayings of various sages.</p>
<p class="mediumspace">
</p><p class="hang1">Fifth Order: Sanctities</p>
<p class="ind"><i>Menahot</i> (<i>Men</i>.)—Meal-offerings: concerning cereal offerings; also concerning <i>tzitzit</i> and <i>tefillin.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_abbreviations.vue?17635b0c